import $ from 'jquery'
import { createApp } from "vue"
import hljs from 'highlight.js'
import 'slick-carousel'
import Quiz from './quiz/quiz'
import { initMediaAsset } from './init_markup_asset_media'
import { embedPracticeGame } from 'practice_games_user/embed'

export function initMarkup($container) {
  setupMarkupQuiz($container)
  addSharedFacts($container)
  smoothScroll($container)
  markupVideoOverlay($container)
  toggleExpandable($container)
  initPracticeGame()
  initHighlightjs()
  initMarkupSlideshow($container)

  $('.markup-media-asset', $container).each(function() {
    initMediaAsset($(this))
  })
}

function setupMarkupQuiz($section) {
  const quizzes = []

  $section.find(".quiz").replaceWith(function() {
    const $quiz = $(this)

    const dataText = $quiz[0].firstChild.data
    const quizResponse = JSON.parse(dataText)
    const questions = quizResponse.questions
    quizzes.push(questions)
    return $("<div class='m-quiz' />")
  })

  quizzes.forEach(questions => {
    const el = $section.find('.m-quiz').get(0)

    createApp(Quiz, { questions }).mount(el);
  })
}

function markupVideoOverlay($mainContainer) {
  const $markupVideoLink = $('.markup-video-link', $mainContainer)

  $markupVideoLink.on('click', function () {
    const videoData = $(this).data("video-id"),
        $modal = $(".markup-video[id=" + videoData + "]");

    SOPHIA.videoJsPlayer($mainContainer);

    SOPHIA.overlayBox($modal, {
      afterClose: function() {
        $.fancybox.destroy();
      }
    });
  })
}

function initMarkupSlideshow($container) {
  $(window).on('load', function() {
    $container.find('.slideshow').slick({
      dots: true,
      infinite: true,
      adaptiveHeight: true
    });
  })
}

function initPracticeGame() {
  $(window).on('load', function() {
    embedPracticeGame()
  })
}

function initHighlightjs() {
  hljs.highlightAll.called = false; // to reinit plugin without page reloading
  hljs.highlightAll();
}

function smoothScroll($container) {
  // to scroll inside current $container area
  $('#toc a[href^="#"]:not(.facts-link)', $container).on('click', function() {
    if ($('body').hasClass('tutorial-page')) {
      $('html, body').animate({
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]', $container).offset().top - 70 //'70' is height of sticky edit panel
      }, 500);
    }
  })

  // additional facts scroll by all page
  $('#toc a[href^="#"].facts-link', $container).on('click', function() {
    if ($('body').hasClass('tutorial-page')) {
      $('html, body').animate({
        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top - 40 //'40' just paddind for correct view
      }, 500);
    }
  })
}

function toggleExpandable($container) {
  const $expandableLink = $('.markup-expandable-title', $container)
  $expandableLink.off('click')
  $expandableLink.off('keydown')

  $expandableLink.on('click', function (event) {
    toggleAccordion(event);
  })

  $expandableLink.on('keydown', function(event) {
    if (event.keyCode == $.ui.keyCode.ENTER) {
      toggleAccordion(event);
    }
  })
}

function toggleAccordion(event) {
  event.preventDefault();

  const $item = $(event.currentTarget).closest('.markup-expandable')
  const $itemAnswer = $(event.currentTarget).siblings('.markup-expandable-content')
  let eventAction

  if ($item.hasClass('expanded')) {
    $item.removeClass('expanded')
    $itemAnswer.slideUp()
    eventAction = 'collapse'
  } else {
    $item.addClass('expanded')
    $itemAnswer.slideDown()
    eventAction = 'expand'
  }

  SOPHIA.clickToggleForGA({
    el: $('a', $item),
    eventAction,
    moduleName: 'Markup expandable element',
    fieldType: 'drawer'
  })
}

function addSharedFacts($container) {
  const $toc = $('#toc', $container)
  const $facts = $('.shared-facts-wrapper')

  if ($toc.length && $facts.length) {
    $('td' ,$toc).append('<ul class="shared-facts-additional-list"></ul>')

    $('.shared-facts-wrapper').each(function(index) {
      let sharedIcon = $('.box-header-icon i', $(this)).attr('class')
      let sharedText = $('.box-header-text', $(this)).text().trim()
      let sharedFactsId = 'shared_facts_'+index
      let hrefLink = '<a href="#'+sharedFactsId+'" class="facts-link"><i class="'+sharedIcon+'"></i>'+sharedText+'</a>'
      let anchor = '<a name="'+sharedFactsId+'"></a>'

      $('.box-header-text', $(this)).prepend(anchor)

      $('.shared-facts-additional-list' ,$toc).append('<li class="shared-facts-additional">'+hrefLink+'</li>')
    })
  }
}
